import React, { Component } from "react";
export default class DropdownOptionGroup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            items: this.props.items,
            title: '',
            selectionCompleted: this.props.selectionCompleted,
            selectedMod: this.props.selectedModifiers
        };
        this.isDropDownOpen = this.isDropDownOpen.bind(this);
        this.isItemSelected = this.isItemSelected.bind(this);
    }

    componentDidMount() {
        if (this.props.selectedModifiers != undefined && this.props.selectedModifiers != null && this.props.selectedModifiers.length > 0) {
            this.props.selectedModifiers.map((id) => {
                this.props.items.map((item) => {
                    if (item.value == id) {
                        this.isItemSelected(item, null, 'first')
                    }
                });
            });
        }
        else {
            const { items } = this.state;
            items.map((item) => {
                if (item.DefaultFlag == true) {
                    this.isItemSelected(item, null, 'first')
                }
            });
           
        }
    }

    // Updates the items array: sets the 'selected' property of the selected item to true
    itemListUpdate(value) {
        const temp = this.state.items;
        temp[value].selected = !temp[value].selected;
        this.setState({
            items: temp
        });
    }

    handleClickOutside() {
        this.setState({
            isOpen: false
        });
    };


    // Keeps track of whether the dropdown is open or closed using the isOpen state
    isDropDownOpen(e) {
        e.preventDefault();
        e.stopPropagation();
        this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
    }

    isItemSelected(itemInput, e, level) {

        if (level == "first") {
            document.getElementById("first" + this.props.id).classList.add("hideCheckClick");
            document.getElementById("second" + this.props.id).classList.remove("hideCheckClick");
        }

        /*if (this.props.reqdStatus == true) {
            document.getElementById(this.props.id + "required").classList.add("hideCheckClick");
            document.getElementById(this.props.id + "required").classList.add("Required");
            document.getElementById(this.props.id + "complete").classList.add("show");
            document.getElementById(this.props.id + "complete").classList.add("showBold");
            document.getElementById(this.props.id + "required").classList.remove("Required");
            document.getElementById(this.props.id + "complete").classList.remove("hideCheckClick");
        }*/

        if (e != null) {
            e.preventDefault();
            e.stopPropagation();
        }
        this.setState({ title: '', selectionCompleted: false });
        const { items } = this.state;

        items.map((item) => {
            if (item.value == itemInput.value) {
                item.selected = "true";
                this.setState({ title: item.label, selectionCompleted: true });
                //this.props.handleSelectBox(item.value, item.label, true)
                this.props.handleSelectBox(item, true);
            } else {
                item.selected = "false";
            }
        });
        this.setState({
            isOpen: false,
            items: items
        });
    }

    render() {
        const { isOpen, title, selectionCompleted } = this.state;

        return (
            <div className="drop-down-container wrapper">
                <div className="list-overflow" id={"first" + this.props.id}>
                    {this.state.items.map((item) => (
                        <div className={item.selected == "true" ? "select-icon drop-down-item" : "drop-down-item"}
                            id={item.value}
                            key={item.value}
                            onClick={(e) => this.isItemSelected(item, e, 'first')}
                            tabIndex="0">
                            {item.label}
                        </div>
                    ))}
                </div>
                <div className="list-dropdown hideCheckClick" id={"second" + this.props.id}>
                    <div className="drop-down-title"> {this.props.title} </div>
                    {/* This is the dropdown component which contains the selected items and the drop down arrow */}
                    <button
                        type="button"
                        className={'dropdown drop-down-width ' + selectionCompleted}
                        onClick={this.isDropDownOpen}>
                        <div className="display-selection" id={"selected-" + this.props.id}>{title}</div>
                        {/* Checks the state of the drop-down and displays the arrows accordingly */}
                        {isOpen ?
                            <div className="arrow-position"></div>
                            :
                            <div className="arrowdown-position"></div>
                        }
                    </button>

                    {/* Displays the list of items when the drop-down is opened */}
                    {isOpen && (
                        <div className="list-overflow">
                            {this.state.items.map((item) => (
                                <div className={item.selected == "true" ? "select-icon drop-down-item" : "drop-down-item"}
                                    key={item.value}
                                    onClick={(e) => this.isItemSelected(item, e, 'second')}
                                    tabIndex="0">
                                    {item.label}
                                </div> 
                            ))}
                        </div>
                    )}                
                </div>
            </div>
        )
    }
}

